// extracted by mini-css-extract-plugin
module.exports = {"careerRecommendJobList__functions":"careerRecommendJobList__functions"};